import { Button } from '@mui/material';
import React from 'react';

const MuiButton = (props) => {
    return (
        <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
                mt: 3,
                mb: 2,
                backgroundColor: '#0D74AE',
                '&:hover': { backgroundColor: '#0A5C89' },
            }}
            {...props}
        >
            {props.children}
        </Button>
    )
}
export default MuiButton